<app-page-title title="Palavra de estudo"></app-page-title>
<div class="title">
  <h2>{{ groupWord?.theme }}</h2>
</div>

<div class="details">
  <h4>
    {{ groupWord?.created_at | date: 'd,  MMMM ' }}de
    {{ groupWord?.created_at | date: 'yyyy' }}
  </h4>
</div>

<div class="container-download">
  <button class="btn-download" mat-raised-button (click)="downloadFile()">
    baixar <img src="../../../assets/icons/file_download_white.svg" />
  </button>
</div>
